module.exports = __webpack_public_path__ + "img/sankaku_69_red.9082bc63.png";